import MyService from '../../service';

const FuelApi = {
  getAllFuel: async () => {
    let result = null;

    await MyService.getRequestData('/vehicles/fuel')
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
};
export default FuelApi;
